module.exports = fox._r("images/tips-text-bg.jpg", __webpack_public_path__ + "images/tips-text-bg.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/tips-text-bg.jpg
// module id = 985
// module chunks = 4